import { render, staticRenderFns } from "./CardsSection.vue?vue&type=template&id=5f63c0ac&scoped=true&"
import script from "./CardsSection.vue?vue&type=script&lang=js&"
export * from "./CardsSection.vue?vue&type=script&lang=js&"
import style0 from "./CardsSection.vue?vue&type=style&index=0&id=5f63c0ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f63c0ac",
  null
  
)

export default component.exports